module.exports = __webpack_public_path__ + "img/delivered.486ad5e3.svg";